import { Box, Stack } from "@mui/material";
import parlors from "goi_common/src/constants/parlors_detail.json";

import {
  ParlorRegionHeadSection,
  ATypeCardView,
  CTypeRegionHead,
  DTypeParlorList,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  ParlorDetailProps,
  numberToLocalString,
  GOI_WEB_URL,
  BTypeBreadCrumb,
  ATypeCTA,
} from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";

// Path 로직 안내
// FUNERAL_SIDO, SIGUNGU의 key로 path 설정.
//
// 1. getStaticPaths 내 key,value 받아서 value(key)로 추가한 뒤 params로 넘기게 변경
// 2. getStaticProps 내 props sido,sigungu, sidoName, sigunguName에 split,replace 로직 추가

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const sidoList = Array.from(FUNERAL_SIDO).filter(([key, val]) =>
    targetSidos.includes(String(key))
  );

  const sidoPath = sidoList.map(([key, val]) => {
    return {
      params: {
        code: `${val} 의 장례식장 목록`,
      },
    };
  });

  const sigunguPaths = Array.from(FUNERAL_SIDO)
    .filter(([key, val]) => targetSidos.includes(String(key)))
    .map(([sidoKey, sidoVal]) => {
      const sigungus = FUNERAL_SIGUNGU.get(sidoKey);
      if (sigungus) {
        return Array.from(sigungus).map(([sigunguKey, sigunguVal]) => {
          return {
            params: {
              code: `${sidoVal}-${sigunguVal} 의 장례식장 목록`,
            },
          };
        });
      }
    })
    .filter((i) => i != null);

  return {
    paths: sidoPath.concat(sigunguPaths?.flat() as Array<any>),
    fallback: false,
  };
};

function getByValue(map: Map<number, any>, searchValue: any) {
  for (const [key, value] of map.entries()) {
    if (value === searchValue) return key;
  }
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.code as string;

  if (code.includes("-")) {
    const [sido, sigungu] = code.split("-");
    const sidoName = sido;
    const sidoNumber = getByValue(FUNERAL_SIDO, sidoName);
    const sigunguName = sigungu.replace(" 의 장례식장 목록", "");
    const sigunguNumber = getByValue(
      FUNERAL_SIGUNGU.get(sidoNumber as number) as any,
      sigunguName
    );

    const regionParlors = parlors.filter(
      (p) => String(p.sigungu) === String(sigunguNumber)
    );

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sidoName} ${sigunguName} 내 ${regionParlors.length}곳의 장례식장을 대상으로 한 비용 비교: 대전, 충청 내 모든 장례식장에 대한 비용을 알아보세요. 근조화환, 실시간 빈소, 장례식장 위치 등 해당 장례식장에 필요한 정보들을 알아보세요.`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName,
        sido: sidoNumber,
        sigunguName,
        sigungu: sigunguNumber,
        isSigungu: true,
        pageDescription: description,
        pageKeywords: `${sidoName} ${sigunguName} 장례식장, ${sidoName} ${sigunguName} 장례식장 추천, ${sidoName} ${sigunguName} 장례식장 비용, ${sidoName} ${sigunguName} 장례식장 평균 예상 비용, ${sidoName} ${sigunguName}  무빈소, ${sidoName} ${sigunguName}  가족장, ${sidoName} ${sigunguName} `,
        pageOgTitle: `${sidoName} ${sigunguName} 지역의 장례식장 목록, 추천, 안내 :: 충청대전세종장례소개포털`,
        pageOgDescription: description,
        pageOgImage:
          regionParlors.length > 0
            ? regionParlors[0]?.images[0]?.url || ""
            : "",
      },
    };
  } else {
    const sidoName = code.replace(" 의 장례식장 목록", "");
    const sidoNumber = getByValue(FUNERAL_SIDO, sidoName);
    const regionParlors = parlors.filter((p) => p.sido === String(sidoNumber));

    const 가족장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["가족장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 무빈소장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["무빈소"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();
    const 일반장 = Number(
      (
        regionParlors.reduce((prev, curr) => {
          return curr.expected_charge_sum["일반장"] + prev;
        }, 0) / regionParlors.length
      ).toFixed(0)
    ).toLocaleString();

    let parlorsString = "";
    regionParlors.map((p: any) => {
      parlorsString += `${p.companyname} ${numberToLocalString(
        p.binsos[0].charge
      )}원, `;
    });

    const description = `${sidoName} 내 ${regionParlors.length}곳의 장례식장을 대상으로 한 비용 비교: 대전, 충청 내 모든 장례식장에 대한 비용을 알아보세요. 근조화환, 실시간 빈소, 장례식장 위치 등 해당 장례식장에 필요한 정보들을 알아보세요.`;

    return {
      props: {
        regionParlors,
        expectedParlorPrice: { 무빈소장, 가족장, 일반장 },
        sidoName,
        sido: sidoNumber,
        isSigungu: false,
        pageDescription: description,
        pageKeywords: `${sidoName} 장례식장, ${sidoName} 장례식장 추천, ${sidoName} 장례식장 비용, ${sidoName} 장례식장 평균 예상 비용, ${sidoName} 무빈소, ${sidoName} 가족장, ${sidoName} `,
        pageOgTitle: `${sidoName} 지역의 장례식장 목록, 추천, 안내 :: 충청대전세종장례소개포털`,
        pageOgDescription: description,
        pageOgImage:
          regionParlors.length > 0
            ? regionParlors[0]?.images[0]?.url || ""
            : "",
      },
    };
  }
};

export default function ParlorSlugTypePage({
  regionParlors,
  expectedParlorPrice,
  pageOgTitle,
  sido,
  sidoName,
  sigungu,
  sigunguName,
  isSigungu,
}: {
  regionParlors: Array<ParlorDetailProps>;
  expectedParlorPrice: { 무빈소장: number; 가족장: number; 일반장: number };
  pageOgTitle: string;
  sido: string;
  sidoName: string;
  sigungu?: string;
  sigunguName?: string;
  isSigungu: boolean;
}) {
  const carouselItems = regionParlors.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.ch-funeralportal.co.kr/parlor-item/${sidoName} ${sigunguName} 의 ${res.companyname}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionParlors.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};

  if (regionParlors.length === 0) {
    return <></>;
  }

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionParlors.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <ParlorRegionHeadSection
        breadCrumb={
          <BTypeBreadCrumb
            firstItem={{
              text: `장례식장 추천`,
              href: GOI_WEB_URL + "/match/request/",
              event: {
                domain: "ch",
                path: "prlr_list",
                trigger_and_target: "br_crumb_mth_req",
              },
            }}
            secondItem={{
              text: `${sidoName} 장례식장`,
              href: `/parlors-list/${sidoName} 의 장례식장 목록/`,
              event: {
                domain: "ch",
                path: "prlr_list",
                trigger_and_target: "br_crumb_sido_prlr_list",
              },
            }}
            thirdItem={
              isSigungu
                ? {
                    text: `${sigunguName} 장례식장`,
                    href: `/parlors-list/${sidoName}-${sigunguName} 의 장례식장 목록/`,
                    event: {
                      domain: "ch",
                      path: "prlr_list",
                      trigger_and_target: "br_crumb_sigungu_prlr_list",
                    },
                  }
                : undefined
            }
            goiHomeEvent={{
              domain: "ch",
              path: "prlr_list",
              trigger_and_target: "br_crumb_goi_home",
            }}
          />
        }
        title={
          <CTypeRegionHead
            regionParlors={regionParlors}
            sidoName={sidoName}
            sigunguName={sigunguName}
            expectedParlorPrice={expectedParlorPrice}
            mainColor={regionColor}
            event={{
              domain: "ch",
              path: "prlr_list",
              trigger_and_target: "uv_mth_req",
            }}
          />
        }
        ctaList={[]}
      />

      <Stack padding="40px 20px">
        <ATypeCTA
          mainColor={regionColor}
          event={{
            domain: "ch",
            path: "prlr_list",
            trigger_and_target: "CTA_uv_mth_req",
          }}
        />
      </Stack>

      <Stack style={{ background: regionColor.c100 }} padding="20px">
        <DTypeParlorList
          sido={sido}
          sigungu={sigungu}
          title={`${sidoName}${
            sigunguName ? " " + sigunguName : ""
          }의 다른 장례식장`}
          binsoAveragePrice={true}
          CardViewType={(res) => (
            <ATypeCardView
              key={res.companyname}
              name={res.companyname}
              href={`/parlor-item/${FUNERAL_SIDO.get(
                Number(res.sido)
              )} ${FUNERAL_SIGUNGU.get(Number(res.sido))?.get(
                Number(res.sigungu)
              )} 의 ${res.companyname}/`}
              descriptions={[
                `빈소 평균 비용 : ${Number(
                  res.binso_average_charge
                ).toLocaleString()}원`,
              ]}
              imgSrc={res.images[0] ? res.images[0].url : ""}
              event={{
                domain: "ch",
                path: "prlr_list",
                trigger_and_target: "uv_prlr_item",
              }}
            />
          )}
        />
        <Box padding="20px 0 " />
        {isSigungu && (
          <DTypeParlorList
            sido={sido}
            title={`${sidoName}의 다른 장례식장`}
            binsoAveragePrice={true}
            CardViewType={(res) => (
              <ATypeCardView
                key={res.companyname}
                name={res.companyname}
                href={`/parlor-item/${sidoName} ${sigunguName} 의 ${res.companyname}/`}
                descriptions={[
                  `빈소 평균 비용 : ${Number(
                    res.binso_average_charge
                  ).toLocaleString()}원`,
                ]}
                imgSrc={res.images[0] ? res.images[0].url : ""}
                event={{
                  domain: "ch",
                  path: "prlr_list_sigun",
                  trigger_and_target: "uv_prlr_item",
                }}
              />
            )}
          />
        )}
      </Stack>
    </>
  );
}
